@if (currentChild(); as currentChild) {
    <app-document-child-info
        [currentChild]="currentChild"
        (back)="handleBack()"
    />
    <app-pre-document-list animate.enter="fade-in" />
} @else {
    <app-document-select-child
        animate.enter="fade-in"
        (currentChildChange)="handleSelectChild($event)"
    />
}
